import _slicedToArray from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import ols from './ols';
import { points, visitPoints } from './points';
import rSquared from './r-squared';
export default function (data, x, y) {
  // eslint-disable-next-line no-unused-vars
  var _points = points(data, x, y),
      _points2 = _slicedToArray(_points, 4),
      xv = _points2[0],
      yv = _points2[1],
      ux = _points2[2],
      uy = _points2[3];

  var YL = 0,
      XY = 0,
      XYL = 0,
      X2Y = 0,
      n = 0,
      dx,
      ly,
      xy;
  visitPoints(data, x, y, function (_, dy) {
    dx = xv[n++];
    ly = Math.log(dy);
    xy = dx * dy;
    YL += (dy * ly - YL) / n;
    XY += (xy - XY) / n;
    XYL += (xy * ly - XYL) / n;
    X2Y += (dx * xy - X2Y) / n;
  });

  var _ols = ols(XY / uy, YL / uy, XYL / uy, X2Y / uy),
      _ols2 = _slicedToArray(_ols, 2),
      c0 = _ols2[0],
      c1 = _ols2[1],
      predict = function predict(x) {
    return Math.exp(c0 + c1 * (x - ux));
  };

  return {
    coef: [Math.exp(c0 - c1 * ux), c1],
    predict: predict,
    rSquared: rSquared(data, x, y, uy, predict)
  };
}